<template>
  <div
    class="app-min-bar d-none"
    v-show="isLinks"
    v-handle-click-outside="handleOnOutSideClick"
    id="dashboard_services_minbar_button"
  >
    <div class="min-bar-container" :class="{ show: isVisible, right: isRight }">
      <slot name="default" />
      <div
        class="mb-item"
        v-for="(link, index) in links"
        @click="handleOpenApp(link.path)"
        v-ripple
        :key="`min-bar-${index}`"
      >
        <FIcon :name="link.icon" size="2.6rem" class="icon" color="2D415A" />
        <span class="label">{{ link.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { LinksConstrains } from "@/enums/links.enum";
import { StorageConstants } from "@/enums/storage.enum";
import Storage from "@/services/storage";

export default {
  name: "AppMinBar",

  data: () => ({
    user: null,
    links: [],
  }),

  props: {
    isVisible: {
      required: true,
      type: Boolean,
      default: false,
    },
    handleOnClose: {
      required: true,
      type: Function,
    },
  },

  computed: {
    /**
     * is RTL
     * return {Boolean}
     */
    isRight() {
      return !this.$vuetify.rtl;
    },

    /**
     * Get user is agent
     * return {Boolean}
     */
    isUserAgent() {
      return this.user?.is_agent || false;
    },

    /**
     * Is OOC App
     * return {Boolean}
     */
    isOOCApp() {
      return process.env.VUE_APP_SHOW_OOC_APP === "true";
    },

    /**
     * Is links not empty
     * @return {boolean}
     */
    isLinks() {
      return this.links.length !== 0;
    },
  },

  mounted() {
    this.initLinks();
  },

  methods: {
    /**
     * Init links in the b=minBar
     * @return{void}
     */
    initLinks() {
      this.user = Storage.get(StorageConstants.SESSION);
      if (this.isUserAgent) {
        this.links.push({
          title: this.$t("call_center"),
          path: "CALL_CENTER_APP",
          icon: "call",
        });
      }

      if (this.isOOCApp) {
        this.links.push({
          title: this.$t("menu.ooc"),
          path: "OOC_MERCHANTS",
          icon: "group",
        });
      }
    },

    /**
     * handle the event on user click out to close the minbar
     */
    handleOnOutSideClick() {
      if (this.isVisible) this.handleOnClose();
    },

    /**
     * handle on open link
     * @return {void}
     */
    handleOpenApp(link = "") {
      window.open(LinksConstrains[link], "_blank");
    },
  },

  directives: {
    /**
     * directive to handel user click out of the auto complete box
     * @directive
     */
    "handle-click-outside": {
      bind: function (el, binding) {
        const { bubble } = binding.modifiers;
        const clickHandler = (e) => {
          if (
            bubble ||
            (!el.contains(e.target) && el !== e.target && e.target.id !== "dashboard_services_minbar_button")
          ) {
            binding.value(e);
          }
        };
        el.__vueHandleClickOutside__ = clickHandler;
        document.addEventListener("click", clickHandler, true);
      },
      unbind: function (el) {
        document.removeEventListener("click", el.__vueHandleClickOutside__);
        el.__vueHandleClickOutside__ = null;
      },
    },
  },
};

/**
 * @name App MinBar
 * @example <MinBar
 *             :isVisible="isVisible"
 *             :handleOnClose="toggole">
 *               <template #body>...</template>
 *          </MinBar>
 * @requires {isVisible: Boolean, handleOnClose: Function}
 */
</script>

<style scoped lang="scss" src="./styles.scss" />
